import { useReduxState } from 'hooks';
import {
  ApiDownloadButton,
  ApiPostButton,
  MoreOptions,
  SendToEmailButton
} from 'components/common';
import { Box } from 'components/common/box';

import type { CourseProgress as CourseProgressData } from 'shared-types';
import type { CourseInView } from 'components/courses/index/Courses';

interface Props {
  course: CourseInView;
  progressData: CourseProgressData;
}

const CourseCertificate = ({ course, progressData }: Props) => {
  const { language, messages, theme, user } = useReduxState();

  return (
    <div className="certificate">
      <Box title={messages.commonCertificate}>
        <div className="inner">
          <ApiDownloadButton
            category="link"
            filename={`${course.title}.pdf`}
            icon={['far', 'file-pdf']}
            iconStyle={{
              color: '#F40F02',
              fontSize: '1.4rem',
              top: 0
            }}
            text={messages.completionsDownloadCertificate}
            url={
              `/admin/certificate` +
              `?completionId=${progressData.completion.id}` +
              `&language=${language}`
            }
          />

          <MoreOptions styleContentButtons={false}>
            {user?.email ? (
              <ApiPostButton
                data={{
                  completionId: progressData.completion.id,
                  emailAddress: user.email,
                  language
                }}
                icon="envelope"
                isDropdown={true}
                successMessage={messages.completionsSendCertificateSuccess}
                text={messages.completionsSendCertificate}
                url="/admin/certificate/send"
              />
            ) : (
              <SendToEmailButton
                apiData={{
                  completionId: progressData.completion.id,
                  language
                }}
                apiUrl="/admin/certificate/send"
                buttonText={messages.completionsSendCertificate}
                id="certificate"
                isDropdown={true}
                successMessage={messages.completionsSendCertificateSuccess}
              />
            )}
          </MoreOptions>
        </div>
      </Box>

      <style jsx>{`
        .inner {
          align-items: center;
          color: ${theme.textColorLight};
          display: flex;
          gap: 20px;
          justify-content: space-between;
        }
      `}</style>
    </div>
  );
};

export default CourseCertificate;
